import React, { useState } from 'react';
import {
  IconChevronDown,
  IconHome2,
  IconUser,
  IconShoppingCart,
  IconArchive,
  IconReceipt2,
  IconBuildingStore,
  IconChartBar,
  IconWallet,
  IconDiamond,
  IconLogout,
  IconMenu2,
  IconX,
  IconClipboardList,
  IconBox,
  IconTags,
  IconShoppingCartOff,
  IconSun,
  IconMoon,
  IconBell,
} from '@tabler/icons-react';
import { http, getAuthorizationHeader } from '../config/http';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import AddJenisBarang from '../components/Admin/AddJenisBarang';
import { useTheme } from '../context/ThemeContext';
import { useNotification } from '../context/NotificationContext';
import { useRefundAccess } from '../hooks/useRefundAccess';
import logoKD from '../assets/logo_kd.png';

const Navbar = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const { pendingCounts } = useNotification();
  const { isRefundAllowed } = useRefundAccess();

  const [openMobile, setMobileOpen] = useState(false);
  const [openMasterMobile, setOpenMasterMobile] = useState(false);
  const [openTransaksiMobile, setOpenTransaksiMobile] = useState(false);

  // ─── STYLING ───
  const activeNav = 'border-b-2 lg:flex items-center py-2 lg:py-3 border-amber-500 text-black font-bold dark:text-amber-400 dark:font-semibold transition-colors';
  const normalLink = 'block py-2 lg:py-3 align-middle lg:flex items-center text-black font-bold dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400';

  async function logout() {
    try {
      await http.post('/auth/logout', {}, {
        headers: { Authorization: getAuthorizationHeader() }
      });
    } catch (err) {
      console.error('Logout error:', err);
    }
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('toko');
    window.dispatchEvent(new Event('logout-success'));
    navigate('/login');
  }

  const check = localStorage.getItem('role');
  const user = localStorage.getItem('name');

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }

  return (
    <nav className="fixed top-0 w-full z-50 shadow-[0_4px_20px_-10px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_20px_-10px_rgba(0,0,0,0.4)] border-b border-amber-300/60 dark:border-slate-800 transition-colors duration-300">
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-200/95 via-amber-100/95 to-yellow-200/95 dark:from-[#0d1527] dark:via-[#0f172a] dark:to-[#0d1527] backdrop-blur-md pointer-events-none -z-10" />
      <AddJenisBarang isOpen={isOpen} closeModal={closeModal} />
      <div className="w-full max-w-5xl lg:max-w-7xl mx-auto flex items-center justify-between py-3 px-4 sm:px-6">

        {/* Brand Logo */}
        <div className="flex items-center">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-amber-50 dark:bg-slate-800 border border-amber-300/60 dark:border-amber-500/30 shadow-sm overflow-hidden p-0.5">
              <img src={logoKD} alt="Komala Dewi" className="w-full h-full object-contain" />
            </div>
            <span className="text-xl sm:text-2xl font-extrabold tracking-wide text-amber-500 dark:text-amber-400">
              Komala Dewi
            </span>
          </Link>
        </div>

        {/* User Profile, Theme Toggle & Menu Toggle */}
        <div className="flex items-center gap-1 sm:gap-2">
          {/* Notification dropdown for pending verifications */}
          {check !== 'kasir' && check !== 'kasir_pembelian' && (
            <div className="relative text-sm">
              <div className="dropdown dropdown-end">
                <label
                  tabIndex={0}
                  className="cursor-pointer p-2 rounded-xl text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-colors relative flex items-center justify-center mr-1"
                  title="Notifikasi Permohonan Verifikasi"
                >
                  <IconBell size={20} />
                  {pendingCounts.total > 0 && (
                    <span className="absolute top-1 right-1 flex h-4 w-4">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                      <span className="relative inline-flex items-center justify-center rounded-full h-4 w-4 text-[9px] font-bold text-white bg-rose-500 shadow-sm">
                        {pendingCounts.total > 9 ? '9+' : pendingCounts.total}
                      </span>
                    </span>
                  )}
                </label>
                <div tabIndex={0} className="dropdown-content menu p-3 mt-2 shadow-xl bg-white dark:bg-slate-800 rounded-2xl w-72 sm:w-80 border border-slate-100 dark:border-slate-700 z-[70]">
                  <div className="flex items-center justify-between pb-2 mb-2 border-b border-slate-100 dark:border-slate-700">
                    <span className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-1.5">
                      <IconBell size={16} className="text-amber-500" />
                      Permohonan Verifikasi
                    </span>
                    {pendingCounts.total > 0 ? (
                      <span className="px-2 py-0.5 text-[11px] font-bold text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/50 rounded-full border border-rose-200 dark:border-rose-900/60">
                        {pendingCounts.total} pending
                      </span>
                    ) : (
                      <span className="text-[11px] text-emerald-600 dark:text-emerald-400 font-medium">
                        Semua Beres
                      </span>
                    )}
                  </div>

                  <div className="space-y-1">
                    {pendingCounts.permohonan_brankas > 0 && (
                      <Link
                        to="/verifikasi-permohonan-brankas-v2"
                        className="flex items-center justify-between p-2 rounded-xl hover:bg-amber-50 dark:hover:bg-slate-700/60 text-slate-700 dark:text-slate-200 transition group"
                      >
                        <div className="flex flex-col">
                          <span className="text-xs font-semibold group-hover:text-amber-600 dark:group-hover:text-amber-400">Pindah Brankas Pusat</span>
                          <span className="text-[10px] text-slate-400">Menunggu persetujuan</span>
                        </div>
                        <span className="px-2 py-0.5 text-[11px] font-bold bg-amber-500 text-white rounded-full">
                          {pendingCounts.permohonan_brankas}
                        </span>
                      </Link>
                    )}

                    {pendingCounts.hapus_etalase > 0 && (
                      <Link
                        to="/verifikasi-hapus-etalase-v2"
                        className="flex items-center justify-between p-2 rounded-xl hover:bg-rose-50 dark:hover:bg-slate-700/60 text-slate-700 dark:text-slate-200 transition group"
                      >
                        <div className="flex flex-col">
                          <span className="text-xs font-semibold group-hover:text-rose-600 dark:group-hover:text-rose-400">Pengajuan Hapus Etalase</span>
                          <span className="text-[10px] text-slate-400">Menunggu persetujuan</span>
                        </div>
                        <span className="px-2 py-0.5 text-[11px] font-bold bg-rose-500 text-white rounded-full">
                          {pendingCounts.hapus_etalase}
                        </span>
                      </Link>
                    )}

                    {pendingCounts.transfer_toko > 0 && (
                      <Link
                        to="/verifikasi-transfer-toko"
                        className="flex items-center justify-between p-2 rounded-xl hover:bg-indigo-50 dark:hover:bg-slate-700/60 text-slate-700 dark:text-slate-200 transition group"
                      >
                        <div className="flex flex-col">
                          <span className="text-xs font-semibold group-hover:text-indigo-600 dark:group-hover:text-indigo-400">Transfer Antar Toko</span>
                          <span className="text-[10px] text-slate-400">Menunggu verifikasi penerimaan</span>
                        </div>
                        <span className="px-2 py-0.5 text-[11px] font-bold bg-indigo-500 text-white rounded-full">
                          {pendingCounts.transfer_toko}
                        </span>
                      </Link>
                    )}

                    {pendingCounts.hapus_pembelian > 0 && (
                      <Link
                        to="/verifikasi-hapus-pembelian"
                        className="flex items-center justify-between p-2 rounded-xl hover:bg-amber-50 dark:hover:bg-slate-700/60 text-slate-700 dark:text-slate-200 transition group"
                      >
                        <div className="flex flex-col">
                          <span className="text-xs font-semibold group-hover:text-amber-600 dark:group-hover:text-amber-400">Hapus Pembelian</span>
                          <span className="text-[10px] text-slate-400">Menunggu persetujuan</span>
                        </div>
                        <span className="px-2 py-0.5 text-[11px] font-bold bg-amber-600 text-white rounded-full">
                          {pendingCounts.hapus_pembelian}
                        </span>
                      </Link>
                    )}

                    {pendingCounts.total === 0 && (
                      <div className="py-4 text-center text-xs text-slate-400">
                        Tidak ada permohonan yang perlu diverifikasi saat ini.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Theme toggle */}
          <button
            onClick={toggleTheme}
            className="p-2 rounded-xl text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-colors mr-1 cursor-pointer"
            title={theme === 'light' ? 'Dark Mode' : 'Light Mode'}
          >
            {theme === 'light' ? <IconMoon size={20} /> : <IconSun size={20} />}
          </button>

          {/* User Profile */}
          <div className="relative text-sm">
            <div className="dropdown dropdown-end">
              <label tabIndex={0} className="cursor-pointer flex items-center gap-2 group p-1.5 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                <div className="w-8 h-8 rounded-full bg-amber-500/20 dark:bg-amber-500/20 border border-amber-500/60 text-amber-600 dark:text-amber-400 flex items-center justify-center font-bold text-sm">
                  {user ? user.charAt(0).toUpperCase() : 'U'}
                </div>
                <div className="font-semibold text-slate-700 dark:text-slate-200 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors hidden sm:block text-sm">
                  {user}
                </div>
                <IconChevronDown size={16} className="text-slate-400 dark:text-slate-400 group-hover:text-amber-500 transition-colors" />
              </label>
              <div tabIndex={0} className="dropdown-content menu p-2 mt-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-52 border border-slate-100 dark:border-slate-700 z-[70]">
                <div className="px-4 py-3 border-b border-slate-100 dark:border-slate-700 mb-1">
                  <p className="text-sm font-semibold text-slate-800 dark:text-slate-200 truncate">{user}</p>
                  <p className="text-xs text-slate-500 dark:text-slate-400 capitalize">{check}</p>
                </div>
                <button
                  onClick={logout}
                  className="w-full text-left py-2.5 px-3 flex items-center gap-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-700 dark:hover:text-red-300 rounded-lg transition-colors font-medium text-sm cursor-pointer"
                >
                  <IconLogout size={18} />
                  Log out
                </button>
              </div>
            </div>
          </div>

          {/* Menu Button (Always visible for kasir & kasir_pembelian, or on mobile for others) */}
          <div className={(check === 'kasir' || check === 'kasir_pembelian') ? 'block' : 'block lg:hidden'}>
            <button
              onClick={() => setMobileOpen(!openMobile)}
              className="flex items-center justify-center p-2 rounded-xl text-slate-600 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-all border border-transparent active:scale-90 cursor-pointer"
              aria-label="Toggle menu"
            >
              <div className={`transition-transform duration-300 ${openMobile ? 'rotate-90' : 'rotate-0'}`}>
                {openMobile ? <IconX size={26} stroke={2.5} /> : <IconMenu2 size={26} stroke={2.5} />}
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Menu Drawer Overlay */}
      <div
        className={`fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] transition-opacity ${(check === 'kasir' || check === 'kasir_pembelian') ? '' : 'lg:hidden'} ${openMobile ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* Menu Drawer */}
      <div
        className={`fixed top-0 left-0 bottom-0 w-[280px] bg-white dark:bg-[#0f172a] z-[110] transform transition-transform duration-300 ${(check === 'kasir' || check === 'kasir_pembelian') ? '' : 'lg:hidden'} shadow-2xl border-r border-slate-200 dark:border-slate-800 overflow-y-auto ${openMobile ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="flex flex-col h-full">
          {/* Header in Drawer */}
          <div className="p-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
            <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center group">
              <div className="w-8 h-8 rounded-lg bg-amber-50 dark:bg-slate-800 border border-amber-300/60 dark:border-amber-500/30 flex items-center justify-center mr-2 shadow-sm transition-transform group-hover:scale-105 p-0.5">
                <img src={logoKD} alt="Komala Dewi" className="w-full h-full object-contain" />
              </div>
              <span className="font-bold text-amber-500 dark:text-amber-400 text-lg">
                Komala Dewi
              </span>
            </Link>
            <button onClick={() => setMobileOpen(false)} className="p-2 text-slate-400 dark:text-slate-400 hover:text-red-500 dark:hover:text-red-400 transition-colors cursor-pointer">
              <IconX size={20} />
            </button>
          </div>

          {/* Navigation Links in Drawer */}
          <div className="flex-1 p-4 space-y-1">
            <NavLink
              to="/"
              onClick={() => setMobileOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                  isActive
                    ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold shadow-sm'
                    : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                }`
              }
            >
              <IconHome2 size={20} />
              <span>Dashboard</span>
            </NavLink>

            {/* Menu khusus Kasir Penjualan */}
            {check === 'kasir' && (
              <>
                <NavLink
                  to="/penjualan"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconShoppingCart size={20} />
                  <span>Kasir Penjualan</span>
                </NavLink>
                {isRefundAllowed && (
                  <NavLink
                    to="/pengembalian"
                    onClick={() => setMobileOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                        isActive
                          ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                          : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                      }`
                    }
                  >
                    <IconShoppingCartOff size={20} />
                    <span>Pengembalian</span>
                  </NavLink>
                )}
                <NavLink
                  to="/transaksi-penjualan"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconReceipt2 size={20} />
                  <span>List Penjualan</span>
                </NavLink>
              </>
            )}

            {/* Menu khusus Kasir Pembelian */}
            {check === 'kasir_pembelian' && (
              <>
                <NavLink
                  to="/pembelian"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconShoppingCart size={20} />
                  <span>Kasir Pembelian</span>
                </NavLink>
                {isRefundAllowed && (
                  <NavLink
                    to="/pengembalian"
                    onClick={() => setMobileOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                        isActive
                          ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                          : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                      }`
                    }
                  >
                    <IconShoppingCartOff size={20} />
                    <span>Pengembalian</span>
                  </NavLink>
                )}
                <NavLink
                  to="/transaksi-pembelian"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconReceipt2 size={20} />
                  <span>List Pembelian</span>
                </NavLink>
              </>
            )}

            {/* Role lainnya */}
            {check !== 'admin' && check !== 'operator' && check !== 'kasir' && check !== 'kasir_pembelian' && (
              <>
                <NavLink
                  to="/penjualan"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconShoppingCart size={20} />
                  <span>Kasir Penjualan</span>
                </NavLink>
                <NavLink
                  to="/transaksi-tertunda"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconClipboardList size={20} />
                  <span>Kasir Penggarus</span>
                </NavLink>
                <NavLink
                  to="/pembelian"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconShoppingCart size={20} />
                  <span>Kasir Pembelian</span>
                </NavLink>
                {isRefundAllowed && (
                  <NavLink
                    to="/pengembalian"
                    onClick={() => setMobileOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                        isActive
                          ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                          : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                      }`
                    }
                  >
                    <IconShoppingCartOff size={20} />
                    <span>Pengembalian</span>
                  </NavLink>
                )}
                <NavLink
                  to="/laporan-cashflow"
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                      isActive
                        ? 'bg-amber-50 dark:bg-amber-950/40 border border-amber-200/50 dark:border-amber-800/40 text-amber-600 dark:text-amber-400 font-bold'
                        : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800/80'
                    }`
                  }
                >
                  <IconChartBar size={20} />
                  <span>Laporan</span>
                </NavLink>
              </>
            )}

            {check !== 'kasir' && check !== 'kasir_pembelian' && check !== 'operator' && (
              <>
                {/* Master Barang Accordion */}
                <div className="space-y-1">
                  <button
                    onClick={() => setOpenMasterMobile(!openMasterMobile)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all ${openMasterMobile ? 'bg-slate-50 dark:bg-slate-800' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}
                  >
                    <div className="flex items-center gap-3">
                      <IconBuildingStore size={20} />
                      <span>Master Barang</span>
                    </div>
                    <IconChevronDown size={16} className={`transition-transform duration-200 ${openMasterMobile ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${openMasterMobile ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <div className="pl-11 pr-4 space-y-1 py-1">
                      <button onClick={() => { openModal(); setMobileOpen(false); }} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconTags size={16} /> Jenis Barang
                      </button>
                      <Link to="/list-items-admin" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconBox size={16} /> Stok Barang
                      </Link>
                      <Link to="/list-items-admin-v2" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconBox size={16} /> Stok Barang V2
                      </Link>
                      <Link to="/barang-opname" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconArchive size={16} /> Stok Opname
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Transaksi Accordion */}
                <div className="space-y-1">
                  <button
                    onClick={() => setOpenTransaksiMobile(!openTransaksiMobile)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all ${openTransaksiMobile ? 'bg-slate-50 dark:bg-slate-800' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}
                  >
                    <div className="flex items-center gap-3">
                      <IconReceipt2 size={20} />
                      <span>Transaksi</span>
                    </div>
                    <IconChevronDown size={16} className={`transition-transform duration-200 ${openTransaksiMobile ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${openTransaksiMobile ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <div className="pl-11 pr-4 space-y-1 py-1">
                      <Link to="/transaksi-penjualan" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm">Penjualan</Link>
                      <Link to="/transaksi-pembelian" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm">Pembelian</Link>
                      <Link to="/summary" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm">Laporan Ringkasan</Link>
                    </div>
                  </div>
                </div>

                <NavLink to="/list-users" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconUser size={20} />
                  <span>Users</span>
                </NavLink>
              </>
            )}

            {check !== 'kasir' && check !== 'kasir_pembelian' && check !== 'operator' && (
              <NavLink to="/saldo-kas" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                <IconWallet size={20} />
                <span>Saldo KAS</span>
              </NavLink>
            )}

            {check !== 'kasir' && check !== 'kasir_pembelian' && (
              <NavLink to="/tambah-barang" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                <IconDiamond size={20} />
                <span>Tambah Barang</span>
              </NavLink>
            )}
          </div>

          {/* Bottom Profile in Drawer */}
          <div className="p-4 border-t border-slate-100 dark:border-slate-800 mt-auto bg-slate-50 dark:bg-slate-800/50">
            <div className="flex items-center gap-3 mb-4 px-2">
              <div className="w-10 h-10 rounded-full bg-amber-400 text-white flex items-center justify-center font-bold">
                {user ? user.charAt(0).toUpperCase() : 'U'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-slate-900 dark:text-white truncate">{user}</p>
                <p className="text-xs text-slate-500 dark:text-slate-400 capitalize">{check}</p>
              </div>
            </div>
            <button
              onClick={logout}
              className="w-full flex items-center justify-center gap-2 py-3 bg-red-50 dark:bg-red-950/40 text-red-600 dark:text-red-400 border border-red-100 dark:border-red-900/30 font-bold rounded-xl active:scale-95 transition-all text-sm cursor-pointer"
            >
              <IconLogout size={18} />
              Keluar Aplikasi
            </button>
          </div>
        </div>
      </div>

      {/* Desktop Navigation Menu (Hidden for Kasir & Kasir Pembelian because Kasir uses the sleek single row header + drawer) */}
      {check !== 'kasir' && check !== 'kasir_pembelian' && (
        <div className="hidden lg:flex lg:items-center w-full container mx-auto px-4 mt-2 bg-transparent pb-0 transition-colors">
          <div className="lg:flex flex-wrap flex-1 items-center gap-x-6 gap-y-2 text-sm">
            <div className="my-1 lg:my-0">
              <NavLink to="/" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                <div className="flex items-center">
                  <IconHome2 size={20} className="mr-2" />
                  <span className="whitespace-nowrap">Dashboard</span>
                </div>
              </NavLink>
            </div>

          {/* Operator/Admin specific menus */}
          {check !== 'admin' && check !== 'operator' && check !== 'kasir' && check !== 'kasir_pembelian' && (
            <>
              <div className="my-1 lg:my-0">
                <NavLink to="/penjualan" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconShoppingCart size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Kasir Penjualan</span>
                  </div>
                </NavLink>
              </div>
              <div className="my-1 lg:my-0">
                <NavLink to="/transaksi-tertunda" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconClipboardList size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Kasir Penggarus</span>
                  </div>
                </NavLink>
              </div>
              <div className="my-1 lg:my-0">
                <NavLink to="/pembelian" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconShoppingCart size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Kasir Pembelian</span>
                  </div>
                </NavLink>
              </div>
              {isRefundAllowed && (
                <div className="my-1 lg:my-0">
                  <NavLink to="/pengembalian" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                    <div className="flex items-center">
                      <IconShoppingCartOff size={20} className="mr-2" />
                      <span className="whitespace-nowrap">Pengembalian</span>
                    </div>
                  </NavLink>
                </div>
              )}
              <div className="my-1 lg:my-0">
                <NavLink to="/laporan-cashflow" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconChartBar size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Laporan</span>
                  </div>
                </NavLink>
              </div>
            </>
          )}

          {/* Admin only menus */}
          {check !== 'kasir' && check !== 'kasir_pembelian' && check !== 'operator' && (
            <>
              <div className="my-1 lg:my-0">
                <div className="dropdown dropdown-bottom lg:dropdown-hover w-full lg:w-auto">
                  <label
                    tabIndex={0}
                    className="block py-2 lg:py-3 align-middle cursor-pointer lg:flex items-center text-black font-bold dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400"
                  >
                    <div className="flex items-center justify-between w-full lg:w-auto">
                      <div className="flex items-center">
                        <IconBuildingStore size={20} className="mr-2" />
                        <span className="whitespace-nowrap">Master Barang</span>
                      </div>
                      <IconChevronDown size={16} className="ml-1" />
                    </div>
                  </label>
                  <ul tabIndex={0} className="dropdown-content menu p-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-full lg:w-52 border border-slate-100 dark:border-slate-700 z-[60]">
                    <li>
                      <button onClick={openModal} className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconTags size={18} className="mr-2" />
                        Jenis Barang
                      </button>
                    </li>
                    <li>
                      <Link to="/list-items-admin" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconBox size={18} className="mr-2" />
                        Stok Barang
                      </Link>
                    </li>
                    <li>
                      <Link to="/list-items-admin-v2" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconBox size={18} className="mr-2" />
                        Stok Barang V2
                      </Link>
                    </li>
                    <li>
                      <Link to="/barang-opname" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconArchive size={18} className="mr-2" />
                        Stok Opname
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="my-1 lg:my-0">
                <div className="dropdown dropdown-bottom lg:dropdown-hover w-full lg:w-auto">
                  <label
                    tabIndex={0}
                    className="block py-2 lg:py-3 align-middle cursor-pointer lg:flex items-center text-black font-bold dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400"
                  >
                    <div className="flex items-center justify-between w-full lg:w-auto">
                      <div className="flex items-center">
                        <IconReceipt2 size={20} className="mr-2" />
                        <span className="whitespace-nowrap">Transaksi</span>
                      </div>
                      <IconChevronDown size={16} className="ml-1" />
                    </div>
                  </label>
                  <ul tabIndex={0} className="dropdown-content menu p-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-full lg:w-52 border border-slate-100 dark:border-slate-700 z-[60]">
                    <li>
                      <Link to="/transaksi-penjualan" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        Penjualan
                      </Link>
                    </li>
                    <li>
                      <Link to="/transaksi-pembelian" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        Pembelian
                      </Link>
                    </li>
                    <li>
                      <Link to="/summary" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        Laporan Ringkasan
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="my-1 lg:my-0">
                <NavLink to="/list-users" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconUser size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Users</span>
                  </div>
                </NavLink>
              </div>
            </>
          )}

          {/* Kasir/Admin Shared */}
          {check !== 'kasir' && check !== 'kasir_pembelian' && check !== 'operator' && (
            <div className="my-1 lg:my-0">
              <NavLink to="/saldo-kas" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                <div className="flex items-center">
                  <IconWallet size={20} className="mr-2" />
                  <span className="whitespace-nowrap">Saldo KAS</span>
                </div>
              </NavLink>
            </div>
          )}

          {/* Operator Shared */}
          {check !== 'kasir' && check !== 'kasir_pembelian' && (
            <div className="my-1 lg:my-0">
              <NavLink to="/tambah-barang" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                <div className="flex items-center">
                  <IconDiamond size={20} className="mr-2" />
                  <span className="whitespace-nowrap">Tambah Barang</span>
                </div>
              </NavLink>
            </div>
          )}
        </div>
      </div>
      )}
    </nav>
  );
};

export default Navbar;
